import React, { PropTypes } from "react";
import { FormattedDate, FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { DataTable } from "../../../../common/DataTable";

import * as dataActions from "../../../../../utils/data/dataActions";

import { EN } from "../../../../common/enums/languages";
import {
  PROCESS_SYNC,
  SUB_PROCESS_SYNC,
} from "../../../../../utils/data/models";
import { BSModal } from "../../../../common";
import { processSyncType } from "./synchronizationTypes";
import { toCamelCase } from "../../../../common/form/DBEnumStringHelper";
import { toast } from "react-toastify";

class SynchronizationDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.getData = this.getData.bind(this);
    this.getSubProcessCount = this.getMemberSubProcessCount.bind(this);
    this.getSubProcessCount = this.getSubProcessCount.bind(this);
    this.getErrorList = this.getErrorList.bind(this);
    this.setStatesForErrorList = this.setStatesForErrorList.bind(this);

    this.state = {
      showErrorModal: false,
      subProcessSyncErrors: null,
      successCountString: "",
      modalBillingPeriod: null,
      modalSyncDate: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { doRefresh, offset, limit, sortBy, q } = this.props;
    if (prevProps.doRefresh !== doRefresh && doRefresh !== 0) {
      this.getData(offset, limit, q, sortBy);
    }
  }

  setStatesForTechnicalError(processSync, userLanguage) {
    this.setState({
      showErrorModal: true,
      subProcessSyncErrors: null,
      successCountString: null,
      modalSyncDate: processSync.startedAt,
      modalBillingPeriod:
        processSync.billingPeriod.localizations[userLanguage].name,
    });
  }

  setStatesForErrorList(processSync, userLanguage) {
    let toastId = toast(
      <span className="import-export-loader">
        <span className="loader">
          <FormattedMessage id="common.loading" />
        </span>
      </span>,
      { autoClose: false, closeButton: false }
    );
    
    let errorsList = "";

    const model = {
      ...SUB_PROCESS_SYNC,
      path: SUB_PROCESS_SYNC.path
        .replace("{clientId}", this.props.clientId)
        .replace("{processSyncId}", processSync.processSyncId),
    };

    this.props.dataActions
      .getDataList(model, 0, 0, "", ["createdAt:desc"], "", {}, {}, "*")
      .then((res) => {
        toast.dismiss(toastId);
        if (res.payload.data) {
          errorsList = res.payload.data.errors;
        }
        if (!errorsList || errorsList.length === 0) {
          this.setStatesForTechnicalError(processSync, userLanguage);
        } else {
          this.setState({
            showErrorModal: true,
            subProcessSyncErrors: errorsList,
            memberSuccessCountString: processSync.memberSuccessCount
              ? `${processSync.memberSuccessCount}/${processSync.memberTotalCount}`
              : "0",
            depSuccessCountString: processSync.depSuccessCount
              ? `${processSync.depSuccessCount}/${processSync.depTotalCount}`
              : "0",
            modalSyncDate: processSync.startedAt,
            modalBillingPeriod:
              processSync.billingPeriod.localizations[userLanguage].name,
          });
        }
      });
  }

  getCols() {
    const userLanguage = localStorage.getItem("languageCode") || EN.value;

    return [
      {
        name: (
          <FormattedMessage id="clients.client.processSync.datatable.billingPeriod" />
        ),
        key: "billingPeriodId",
        display: (processSync) => (
          <span>
            {processSync.billingPeriod.localizations[userLanguage].name}
          </span>
        ),
        widthPct: 20,
      },
      {
        name: (
          <FormattedMessage id="clients.client.processSync.datatable.status" />
        ),
        key: "status",
        display: (processSync) => {
          const isFailedProcess = [
            processSyncType.FAILURE,
            processSyncType.INCOMPLETE,
          ].includes(processSync.status);
          const cssStatus = isFailedProcess
            ? "status-incomplete"
            : processSync.status == processSyncType.SUCCESS
            ? "status-success"
            : "status-ongoing";
          return (
            <div>
              <span className={`status-indicator ${cssStatus}`}>
                <FormattedMessage
                  id={`clients.client.processSync.datatable.statusTypes.${processSync.status.toLowerCase()}`}
                />
              </span>
              {isFailedProcess && (
                <span
                  className="icon-eye icon-eye-status"
                  onClick={() =>
                    this.setStatesForErrorList(processSync, userLanguage)
                  }
                />
              )}
            </div>
          );
        },
        widthPct: 13,
      },
      {
        name: <FormattedMessage id="clients.client.processSync.datatable.memberSynchronizedCoverages" />,
        display: (processSync) =>
          processSync.memberSuccessCount != undefined
            ? `${processSync.memberSuccessCount}/${processSync.memberTotalCount}`
            : "",
        widthPct: 20,
      },
      {
        name: <FormattedMessage id="clients.client.processSync.datatable.dependentSynchronizedCoverages" />,
        display: (processSync) =>
          processSync.depSuccessCount != undefined
            ? `${processSync.depSuccessCount}/${processSync.depTotalCount}`
            : "",
        widthPct: 20,
      },
      {
        name: (
          <FormattedMessage id="clients.client.processSync.datatable.startedAt" />
        ),
        key: "startedAt",
        display: (processSync) => (
          <FormattedDate
            value={processSync.startedAt}
            year="numeric"
            month="long"
            day="2-digit"
            hour="numeric"
            minute="numeric"
          />
        ),
        widthPct: 18,
        reverseSortOrder: true,
        displayReverseSortOrder: true,
      },
      {
        name: (
          <FormattedMessage id="clients.client.processSync.datatable.duration" />
        ),
        display: (processSync) => {
          const createdAtDate = Date.parse(processSync.createdAt);
          const updatedAtDate = Date.parse(processSync.updatedAt);

          const diffInSeconds = (updatedAtDate - createdAtDate) / 1000;

          const hours = Math.floor(diffInSeconds / 3600);
          const minutes = Math.floor((diffInSeconds % 3600) / 60);
          const seconds = Math.floor(diffInSeconds % 60);

          return <span>{`${hours}h ${minutes}m ${seconds}s`}</span>;
        },
        widthPct: 9,
      },
    ];
  }

  getData(offset, limit, q, sortBy) {
    const model = {
      ...PROCESS_SYNC,
      path: PROCESS_SYNC.path.replace("{}", this.props.clientId),
    };

    return this.props.dataActions.getDataList(
      model,
      offset,
      limit,
      q,
      sortBy,
      "",
      {},
      {},
      "*,subProcessSync(errors)"
    );
  }

  getMemberSubProcessCount() {
    const { subProcessSyncErrors, memberSuccessCountString } = this.state;
    if (!subProcessSyncErrors) {
      return "";
    }

    return `${this.context.intl.formatMessage({
      id: "clients.client.processSync.synchronizedMemberCoverages",
    })}: ${memberSuccessCountString}\n\n`;
  }

  getDepSubProcessCount() {
    const { subProcessSyncErrors, depSuccessCountString } = this.state;
    if (!subProcessSyncErrors) {
      return "";
    }

    return `${this.context.intl.formatMessage({
      id: "clients.client.processSync.synchronizedDepCoverages",
    })}: ${depSuccessCountString}\n\n`;
  }

  getErrorList() {
    const { subProcessSyncErrors } = this.state;
    if (!subProcessSyncErrors) {
      return [
        this.context.intl.formatMessage({
          id: "clients.client.processSync.errors.technicalError",
        }),
      ];
    }

    let errorList = [];
    if (subProcessSyncErrors && subProcessSyncErrors.length > 0) {
      subProcessSyncErrors.forEach((error) => {
        let displayedError = null;
        if (error.hasOwnProperty("key")) {
          const key = toCamelCase(error["key"]);
          const identifier = error.hasOwnProperty("identifier")
            ? error["identifier"]
            : {};
          let displayedIdentifiers = {};
          Object.keys(identifier).forEach((key) => {
            if (key == "field")
              displayedIdentifiers[key] = this.context.intl.formatHTMLMessage({
                id: `clients.client.processSync.errorIdentifiers.fields.${identifier[key]}`,
              });
            else displayedIdentifiers[key] = identifier[key];
          });
          displayedError = this.context.intl.formatMessage(
            {
              id: `clients.client.processSync.errorIdentifiers.${key}`,
            },
            displayedIdentifiers
          );
        } else displayedError = error["Text"];
        if (displayedError) errorList.push(displayedError);
      });
    }
    return errorList;
  }

  render() {
    const { modalBillingPeriod, modalSyncDate } = this.state;

    const modalTitle =
      modalBillingPeriod +
      " - " +
      this.context.intl.formatDate(modalSyncDate, {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    return (
      <div>
        <DataTable
          ref="dataTable"
          title={
            <FormattedMessage id="clients.client.processSync.datatable.title" />
          }
          getData={this.getData}
          cols={this.getCols()}
          filters={this.props.filters}
          offset={this.props.offset}
          q={this.props.q}
          data={this.props.items}
          rowsPerPage={this.props.limit}
          totalRows={this.props.total}
          sortBy={this.props.sortBy}
        />

        <BSModal
          show={this.state.showErrorModal}
          title={modalTitle}
          onClose={() => this.setState({ showErrorModal: false })}
        >
          <div className="modal-spacing-break">
            <span className="scrollable-modal">
              {this.getMemberSubProcessCount()}
              {this.getDepSubProcessCount()}
              <br />
              <ul>
                {this.getErrorList().map((sub, i) => {
                  return <li key={i}>{sub}</li>;
                })}
              </ul>
            </span>
          </div>
        </BSModal>
      </div>
    );
  }
}

SynchronizationDataTable.propTypes = {
  clientId: PropTypes.number,
  q: PropTypes.string,
  doRefresh: PropTypes.number,
  offset: PropTypes.number,
  limit: PropTypes.number,
  sortBy: PropTypes.array,
  dataActions: PropTypes.object,
  filters: PropTypes.array,
  total: PropTypes.number,
  items: PropTypes.array,
};

SynchronizationDataTable.contextTypes = {
  intl: intlShape,
};

function mapStateToProps(state) {
  const data = state.data.processSyncs || {};
  const pagination = data.pagination || {};

  return {
    clientId: state.data.clients.active.clientId,
    limit: 50,
    offset: pagination.offset || 0,
    sortBy: data.sortBy || ["startedAt:desc"],
    q: data.q || "",
    total: pagination.totalCount || 0,
    items: data.items || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SynchronizationDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/synchronizations/SynchronizationDataTable.js